// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Components
import { ModuleHeader } from '../../../../../../layout/elements/ModuleHeader';

// View
import { FeederInterlockProps } from './FeederInterlock.types';

function FeederInterlock({
  className,
  onOpenDrawer,
  testId,
}: FeederInterlockProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  return (
    <div
      data-testid={testId}
      className={className}
    >
      <ModuleHeader
        onClick={onOpenDrawer}
        title={t('view.crusher.feederInterlock.title')}
        testId={`${testId}-module-header`}
      />
    </div>
  );
}

export { FeederInterlock };
